import React, { Component } from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import _ from 'lodash';
import { getProposalData } from '../src/scripts/actions/proposal';
import utils from '../src/scripts/utils/utils';
import { Router } from '../src/scripts/routes';
import EventProposal from '../src/scripts/components/proposals/EventProposal';
import '../src/styles/components/event-proposal.styl';

const { liveGalleryURL } = require('../src/scripts/constants').get();

class EventProposalPage extends Component {
  static async getInitialProps({ req, store, isServer, query }) {
    const { eventId, embedMode: embedModeString } = query;
    const isEmbedMode = !_.isNil(embedModeString);
    const isSalsaEvent = utils.getApiName(eventId) === 'salsa';
    if (isServer) {
      const domain = req.headers.host;
      const subdomain = domain ? domain.split('.')[0] : undefined;
      if (isSalsaEvent) {
        store.dispatch(getProposalData(eventId, true));
      }
    }
    return { isSalsaEvent, eventId, isServer, isEmbedMode };
  }

  componentDidMount() {
    const { isSalsaEvent, licenseCount } = this.props;
    if (!isSalsaEvent /* || licenseCount < 1 */) {
      window.location = liveGalleryURL;
    }
    document.documentElement.classList.remove('preload');
  }

  render() {
    const {
      isServer,
      isSalsaEvent = false,
      eventId,
      eventTitle,
      eventLoaded = false,
      isEmbedMode = false,
    } = this.props;

    if (!isSalsaEvent) {
      return null;
    }

    return (
      <div className="page">
        <Head>
          <title>{eventTitle}</title>
        </Head>
        <EventProposal eventId={eventId} isEmbedMode={isEmbedMode} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const event = state.proposalData;
  return {
    eventId: ownProps.eventId,
    eventTitle: event.data.title,
    eventLoaded: !!event.success,
    licenseCount: event.data.organization ? event.data.organization.licenseCount : 0,
  };
};

export default connect(mapStateToProps)(EventProposalPage);
